export function isCandidatePreRegistered(event) {
  return event.isAuthUserPreregistered;
}